import {
  createDirectus,
  rest,
  readItems,
  updateItem,
  authentication,
  updateItems,
} from "@directus/sdk";

const client = createDirectus(location.origin)
  .with(authentication("cookie"))
  .with(rest());

async function get(filter, fields) {
  let obj = {
    fields: fields ? fields : ["*"],
    sort: ["-date_created"],
  };
  if (filter && Object.keys(filter).length !== 0) {
    obj.filter = filter;
  }

  const data = await client.request(readItems("notifications", obj));
  return data;
}

async function readById(id, date_read) {
  let data = { date_read };
  return await client.request(
    updateItem("notifications", id, data, {
      fields: ["*"],
    })
  );
}
async function readByIds(ids, date_read) {
  let data = { date_read };
  return await client.request(
    updateItems("notifications", ids, data, {
      fields: ["*"],
    })
  );
}
async function hideById(id, date_hidden) {
  let data = { date_hidden };
  return await client.request(
    updateItem("notifications", id, data, {
      fields: ["*"],
    })
  );
}
async function hideByIds(ids, date_hidden) {
  let data = { date_hidden };
  return await client.request(
    updateItems("notifications", ids, data, {
      fields: ["*"],
    })
  );
}
export default {
  readById,
  get,
  hideById,
  hideByIds,
  readByIds,
};
